import { toast } from 'sonner';

const hrefs = new Map<string | number, string>();

export function setToastHref(id: string | number, href: string): void {
  hrefs.set(id, href);
  if (hrefs.size > 50) hrefs.delete(hrefs.keys().next().value as string | number);
}

export function takeToastHref(id: string | number): string | undefined {
  const href = hrefs.get(id);
  hrefs.delete(id);
  return href;
}

const ID_CLASS = 'toast-id-';

export function toastIdClass(id: string | number): string | undefined {
  const token = String(id);
  return /^[A-Za-z0-9_-]+$/.test(token) ? ID_CLASS + token : undefined;
}

export function toastIdFromNode(node: HTMLElement): string | number | undefined {
  const token = Array.from(node.classList)
    .find((c) => c.startsWith(ID_CLASS))
    ?.slice(ID_CLASS.length);
  if (!token) return undefined;
  return toast.getToasts().find((t) => String(t.id) === token)?.id;
}
